import styles from './index.module.sass';
import { useTranslation } from 'react-i18next';

// Components
import OrderCard from '../../../../OrderCard';
import Button from '@mui/material/Button';

const Wellcome = ({ recordSuccess = {}, history }) => {
  const { t } = useTranslation('contractus');

  return (
    <div className={styles.wellcome}>
      <div className={styles.goldTitle}>{t('welcomeGold')}</div>
      <div className={styles.blueSubtitle}>{t('welcomeBlue')}</div>
      <div className={styles.titleWelcome}>{t('textSuccess2')}</div>

      {/* <OrderCard>
        <div className={styles.blackLabel}>
          {t('success1')} {recordSuccess.nombreCompleto}
        </div>
        <div className={styles.textSuccess}>{t('textSuccess')}</div>
        <div className={styles.verify}>
          <div className={styles.validateSMS} onClick={() => history.push('validate')}>
            <span className={`material-icons`}>verified</span>
            <label className={styles.validateText}>{t('validateCode')}</label>
          </div>
        </div>
      </OrderCard> */}

      <OrderCard>
        <div className={styles.numKit}>
          <label className={styles.blackLabel}>
            {t('numKit')} {recordSuccess.kit}
          </label>
        </div>
        <br />
        <div className={styles.textSuccess}>{t('msj')}</div>
        <div className={styles.textSuccess}>
          <label className={styles.labelGold}>{t('nameConsult')}:</label>
          <label className={`${styles.blackLabel} ${styles.paddingLeft}`}>
            {recordSuccess.nombreCompleto}
          </label>
          <br />
          <label className={styles.labelGold}>KIT:</label>
          <label className={`${styles.blackLabel} ${styles.paddingLeft}`}>
            TM{recordSuccess.kit}
          </label>
          <br />
          <label className={styles.labelGold}>{t('labelPass')}</label>
          <label className={`${styles.blackLabel} ${styles.paddingLeft}`}>
            {recordSuccess.contrasenia}
          </label>
        </div>
        <br />
        <div className={styles.finishButton}>
          <Button
            variant='contained'
            color='primary'
            className={styles.buttonFinish}
            onClick={(e) => window.location.reload()}>
            {t('finishButton')}
          </Button>
        </div>
      </OrderCard>
    </div>
  );
};

export default Wellcome;
